import isPromise from 'is-promise';
import { BasicValidation } from './BasicValidation';

const validationStore = {};

export const addValidation = (key, fn) => {
  validationStore[key] = fn;
};

export const addMultipleValidations = (obj) => {
  Object.keys(obj).forEach(key => addValidation(key, obj[key]));
};

addMultipleValidations(BasicValidation);


export const generateAsyncValidation = validationConfig =>
  (values, dispatch, props, blurredField) => {
    const promiseList = [Promise.resolve()];
    const errors = {};

    const addError = (field, validatorName, message = true) => {
      if (!errors[field]) {
        errors[field] = {};
      }
      errors[field][validatorName] = message;
    };

    Object.keys(validationConfig).map((fieldName) => {
      const validation = validationConfig[fieldName];
      if (typeof validation === 'object') {
        Object.keys(validation).map((validationType) => {
          if (typeof validationStore[validationType] !== 'function') {
            return null;
          }
          const value = typeof values.get === 'function' ? values.get(fieldName) : values[fieldName]; // immutableJS
          const hasError = validationStore[validationType](
            fieldName,
            value,
            validation[validationType],
            dispatch,
            values,
            validation,
            props,
            blurredField);
          if (isPromise(hasError)) {
            promiseList.push(new Promise((resolve) => {
              hasError.then(resolve).catch((msg) => {
                addError(fieldName, validationType, msg);
                resolve();
              });
            }));
          } else if (hasError) {
            addError(fieldName, validationType, hasError);
          }
          return null;
        });
      }
      return null;
    });
    return Promise.all(promiseList).then(() => {
      if (Object.keys(errors).length) {
        return Promise.reject(errors);
      }
      return null;
    });
  };

export const generateAsyncBlurFields = validationConfig =>
  Object.keys(validationConfig).filter(fieldName =>
    typeof validationConfig[fieldName] === 'object' && validationConfig[fieldName].validateOnBlur);

export const generateValidation = validationConfig =>
  ({
    asyncValidate: generateAsyncValidation(validationConfig),
    asyncBlurFields: generateAsyncBlurFields(validationConfig),
    fields: Object.keys(validationConfig),
  });
